import { render, staticRenderFns } from "./Redirect.vue?vue&type=template&id=0619ed76&scoped=true"
import script from "./Redirect.vue?vue&type=script&lang=js"
export * from "./Redirect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0619ed76",
  null
  
)

export default component.exports